import * as Sentry from "@sentry/vue";

function getSentryIntegrations() {
    // don't load on server
    if (!import.meta.client) return [];

    return [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration(),
    ];
}

export default defineNuxtPlugin({
    name: 'sentry',
    parallel: true,
    async setup(nuxtApp) {
        const vueApp = nuxtApp.vueApp;

        const config = useRuntimeConfig();

        Sentry.init({
            app: vueApp,
            dsn: config.public.SentryDnsPublic as string,
            integrations: getSentryIntegrations(),
            tracesSampleRate: 1,
        });
    }
});
